<template>
  <li :class="{ 'left-b-l': true, 'active': active }" @click="selectItem">
    <div class="nav">
      <aside v-if="unread>0">{{unread}}</aside>
      <img :src="avatar" alt="" />
    </div>
    <div class="nav1">
      <section>
        <b>{{ name }}</b>
        <span>{{ time }}</span>
      </section>
      <p>{{ content }}</p>
    </div>
  </li>
</template>

<script>
//import dafaultImg from '@/assets/chat-img/img1.png'
export default {
  // props: ["img", "name", "time", "dialogue"],
  props: {
    index: {
      type: Number
    },
    
    avatar: {
      type: String,
      default: ""
    },
    name: {
      type: String
    },
    time: {
      type: String
    },
    content: {
      type: String
    },
    active: {
      type: Boolean,
      default:false
    },
    unread: {
      type: Number,
      default:0
    },
  },
  data () {
    return {
      //dafaultImg: dafaultImg
    }
  },

  methods:{
    selectItem(){
      this.$emit("selectItem",this.index);
    }
  }
};
</script>

<style lang="scss" scoped>
.left-b-l {
  display: flex;
  width: 316px;
  height: 77px;
  box-sizing: border-box;
  padding: 5px 12px 5px 0;
}

//.left-b-l:hover,
.left-b-l.active {
  background-color: #eef2ff;
}

.left-b-l .nav {
  width: 67px;
  display: flex;
  justify-content: center;
  align-items: center;
  position:relative;
}

.nav aside {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 12px;
  left: 34px;
  color: #fff;
  background-color: #ff4e4e;
  border-radius: 10px;
  line-height: 20px;
  font-size: 12px;
  text-align: center;
}

.left-b-l img {
  width: 43px;
  height: 43px;
  border-radius: 50%;
}
.left-b-l .nav1 {
  width: 249px;
  // background-color: blue;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
}

.left-b-l .nav1 section {
  width: 249px;
  padding-right: 11px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  display: flex;
  justify-content: space-between;
}

.left-b-l .nav1 section b {
  display: block;
}

.left-b-l .nav1 section span {
  display: block;
  font-size: 11px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
}

.left-b-l .nav1 p {
  font-size: 11px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>